import { useTranslation } from "react-i18next";
import React from "react";
import moroccoFlag from '../../images/morocco_flag.avif';
import usFlag from '../../images/united-states_flag.avif';
import { PrincipaleButton } from "../PrincipaleButton";


export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();

  function handleLanguageChange() {
    const currentLanguage = i18n.language;
    const nextLanguage = currentLanguage === "en" ? "ar" : "en";
    i18n.changeLanguage(nextLanguage);
  }
  return (
    <PrincipaleButton className="language-switcher" onClick={handleLanguageChange} margin={{ top: "10px", bottom: "10px" }} fontWeight={400} padding="10px 10px">
    {i18n.language === 'en' ? (
      <>
        {t('عربي')}
        <img src={moroccoFlag} alt="Moroccan flag" style={{ maxWidth: '20px', maxHeight: '20px' }} />
      </>
    ) : (
      <>
        <img src={usFlag} alt="US flag" style={{ maxWidth: '20px', maxHeight: '20px' }} />
        {t('english')}
      </>
    )}
  </PrincipaleButton>
  );
}
